import {
  LiteRaveSignupRequest,
  LiteRaveSignupResult,
  LiteRaveClaimCodeRequest,
  LiteRaveClaimCodeResult,
} from "@t3/shared";
import { createHttpsCallableHook } from "./createHttpsCallableHook";

const middlewareOnCallSignupRequest = (request: LiteRaveSignupRequest) => {
  if (!request.email) {
    throw new Error("Email is required");
  }
  if (!request.code) {
    throw new Error("Redemption code is required");
  }
  return request;
};

const middlewareOnCallClaimCodeRequest = (
  request: LiteRaveClaimCodeRequest,
) => {
  if (!request.code) {
    throw new Error("Redemption code is required");
  }
  return request;
};

export const useVerifyLiteRaveSignup = createHttpsCallableHook<
  LiteRaveSignupRequest,
  LiteRaveSignupResult
>("verifyLiteRaveSignup", middlewareOnCallSignupRequest);

export const useClaimLiteRaveCode = createHttpsCallableHook<
  LiteRaveClaimCodeRequest,
  LiteRaveClaimCodeResult
>("claimLiteRaveCode", middlewareOnCallClaimCodeRequest);
